﻿import {type RouteRecordRaw} from "vue-router";

export const Home: RouteRecordRaw = {
    path: '/home',
    component: () => import('./index.vue'),
};

export default [
    Home,
];
